// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth"
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyB86pMYBxEQMkQLuw2ZLVSV-upvN7Mq4S4",
  authDomain: "syncverse-firebase.firebaseapp.com",
  projectId: "syncverse-firebase",
  storageBucket: "syncverse-firebase.appspot.com",
  messagingSenderId: "617424391852",
  appId: "1:617424391852:web:9297f4c9f86dd5c9489909",
  measurementId: "G-GY1HMHKXR5"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const auth = getAuth(app);